/*
 * Copyright (c) 2023. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
export * from './basis-of-design';
export * from './icrs';
export * from './met-stations';
export * from './opportunities';
export * from './pricing-scenarios';
export * from './project-llcs';
export * from './projects';
export * from './sites';
export const BASE_SF_URL = 'https://brightnightpower.lightning.force.com/lightning';
export var SalesforceObject;
(function (SalesforceObject) {
    SalesforceObject["account"] = "Account";
    SalesforceObject["contact"] = "Contact";
    SalesforceObject["opportunity"] = "Opportunity";
    SalesforceObject["bid"] = "Bid__c";
    SalesforceObject["pricing_scenario"] = "Pricing_Scenario__c";
    SalesforceObject["project"] = "Project__c";
    SalesforceObject["user"] = "User";
    SalesforceObject["project_llc"] = "Project_LLC__c";
    SalesforceObject["basis_of_design"] = "Basis_of_Design__c";
    SalesforceObject["storage"] = "Storage__c";
    SalesforceObject["icr"] = "IC_Request__c";
    SalesforceObject["transmission"] = "Transmission__c";
    SalesforceObject["report"] = "Report";
    SalesforceObject["met_station"] = "Met_Station__c";
    SalesforceObject["site"] = "Site__c";
    SalesforceObject["parcel"] = "Parcel__c";
})(SalesforceObject || (SalesforceObject = {}));
export var UserProfile;
(function (UserProfile) {
    UserProfile["US_DEV"] = "US Development";
    UserProfile["US_ORIG"] = "US Origination";
    UserProfile["US_FIN"] = "US Finance";
    UserProfile["US_ENG"] = "US Engineering";
    UserProfile["ASIA_DEV"] = "Asia Development";
    UserProfile["ASIA_ORIG"] = "Asia Origination";
    UserProfile["ASIA_FIN"] = "Asia Finance";
    UserProfile["ASIA_ENG"] = "Asia Engineering";
    UserProfile["OTHER"] = "Other";
})(UserProfile || (UserProfile = {}));
//# sourceMappingURL=index.js.map